import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { ListItemSection, ListItemSelect, DropdownModal } from 'wix-rich-content-toolbars-ui';
import { layoutData } from './PollButtonsData.js';
import '../assets/icons/LayoutGridIconNew.js';
import '../assets/icons/LayoutListIconNew.js';

const PollLayoutPanel = ({
  getSelectedLayout,
  onClick,
  onCustomizeButtonClick
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const onKeyDown = (e, onClick2) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick2();
      e.stopPropagation();
    }
  };
  const CustomizeButton = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListItemSection, { type: "divider" }), /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      title: t("Poll_Mobile_Editor_Toolbar_Customize"),
      onClick: onCustomizeButtonClick,
      dataHook: "poll_layout_modal_button",
      onKeyDown: (e) => onKeyDown(e, onCustomizeButtonClick)
    }
  ));
  const LayoutButtons = layoutData.map(({ dataHook, icon: Icon, text, commandKey }) => {
    const onButtonClick = () => onClick(commandKey);
    return /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        key: commandKey,
        title: t(text),
        dataHook,
        prefix: /* @__PURE__ */ React.createElement(Icon, null),
        selected: commandKey === getSelectedLayout(),
        onClick: onButtonClick,
        onKeyDown: (e) => onKeyDown(e, onButtonClick)
      }
    );
  });
  const DropdownOptions = [...LayoutButtons, CustomizeButton];
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};

export { PollLayoutPanel as default };
//# sourceMappingURL=PollLayoutPanel.js.map
